import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { router } from "../App";

const RedirectToForm = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate("/" + i18n.resolvedLanguage + "/form", { replace: true });

    return () => {};
  }, []);

  /* useEffect(() => {
    navigate("/");
  }, []); */

  useEffect(() => {
    const isMatchingRoute = router.routes.some(
      (route) => route.path === location.pathname
    );

    if (!isMatchingRoute) {
      navigate("/" + i18n.resolvedLanguage + "/form", { replace: true });
    }
  }, [location.pathname, navigate, router.routes]);

  return <></>;
};

export default RedirectToForm;
